export enum ConnectivityIssueType {
  NETWORK_CONNECTION = 'network_connection',
  NETWORK_DISCONNECTION = 'network_disconnection',
}
